import { Flex } from "@chakra-ui/react";

import CompanyCardItem from "./companyCardItem";

const CompaniesCards = ({ companies }) => {
  return (
    <Flex direction={"column"} rowGap={"12px"} px={"24px"}>
      {companies?.map((item) => (
        <CompanyCardItem key={item?.id} item={item} />
      ))}
    </Flex>
  );
};

export default CompaniesCards;
